import { createClient } from "@supabase/supabase-js";

const supabaseUrl  = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey  = process.env.REACT_APP_SUPABASE_ANON_KEY;
const autosaveOn   = process.env.REACT_APP_ENABLE_AUTOSAVE !== "false";

if (!supabaseUrl || !supabaseKey) {
  console.warn(
    "[DPL Jade] Supabase env vars not set — running in local-only mode.\n" +
    "Copy .env.example → .env.local and fill in your project credentials."
  );
}

/**
 * Supabase client — may be null if env vars are missing (local-only mode).
 */
export const supabase = supabaseUrl && supabaseKey
  ? createClient(supabaseUrl, supabaseKey)
  : null;

/**
 * True when Supabase is configured AND autosave is enabled.
 */
export const canPersist = !!supabase && autosaveOn;
